import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';
import { TokenStorageService } from '../_services/token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ClientService { 
  baseUrl = environment.baseUrl;

  constructor(
    private router: Router, 
    private http: HttpClient, 
    private tokenStorage: TokenStorageService
  ) { }

  getClientListLanguages$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'languages?uuid=' + uuid);
  }

  getClientListContactTypes$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'contact-types?uuid=' + uuid);
  }

  getClientListReferrals$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.lookup}`;
    return this.http.get<any>(url + 'referrals?uuid=' + uuid);
  }

  addClient$(uuid: string, client: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    return this.http.post<any>(url + '?uuid=' + uuid, client, httpOptions);
  }
  
  getClients$(uuid: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    let offset = page * 10;
    return this.http.get<any>(url + '?uuid=' + uuid + '&offset=' + offset);
  }

  getClient$(uuid: string, client_id: number): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.clients}`;
    return this.http.get<any>(url + client_id + '?uuid=' + uuid);
  }

  modifyClient$(uuid: string, client_id: number, clientInfo: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    return this.http.put<any>(url + client_id +'?uuid=' + uuid, clientInfo, httpOptions);
  }

  deleteClient$(uuid: string, client_id: number, clientInfo: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    return this.http.post<any>(url + client_id + '?uuid=' + uuid, clientInfo, httpOptions);
  }

  modifyClientContact$(uuid: string, client_id: number, clientContactInfo: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    let payload = {contacts: clientContactInfo};
    return this.http.put<any>(url + client_id +'/contacts/bulk-update?uuid=' + uuid, payload, httpOptions);
  }

  searchClient$(uuid: string, search: string, page: number): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    let offset = page * 10;
    ///ookup2
    return this.http.get<any>(url + 'search?query=' + search + '&uuid=' + uuid + '&offset=' + offset);
  }

  getAutoClientsName$(uuid: string, search: string, auto_category: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.clients}`;
    let limit = 100;
    return this.http.get<any>(url + 'search_select?query=' + search + '&uuid=' + uuid + '&field=' + auto_category + '&limit=' + limit);
  }
}
